import { createContext, useContext } from 'react';
import { type SearchClient } from 'algoliasearch/lite';

type SearchClientContextType = {
  searchClient: SearchClient;
  searchIndexes: { default: string; [key: string]: string };
};

export const SearchClientContext = createContext<SearchClientContextType | undefined>(undefined);

export const useSearchClient = () => {
  const context = useContext(SearchClientContext);
  if (context === undefined) {
    throw new Error('useSearchClient must be used within a TypesenseProvider');
  }
  return context;
};

// Non-throwing variant for code paths that may run without a search provider
// (e.g. shares, where search is intentionally unavailable). Returns undefined
// when there is no TypesenseProvider above.
export const useOptionalSearchClient = () => useContext(SearchClientContext);
